function UserCircleIcon({ className }) {
  return (
    <svg className={`ic ${className}`} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.12">
        <path
          d="M24.9118 25.918C22.5502 28.0414 19.4261 29.3335 16.0002 29.3335C12.5743 29.3335 9.45024 28.0414 7.08862 25.918C7.89972 24.0071 9.79346 22.6668 12.0002 22.6668H20.0002C22.207 22.6668 24.1007 24.0071 24.9118 25.918Z"
          fill="currentColor"
        />
        <path
          d="M16.0001 18.0002C18.9456 18.0002 21.3334 15.6123 21.3334 12.6668C21.3334 9.72131 18.9456 7.3335 16.0001 7.3335C13.0546 7.3335 10.6667 9.72131 10.6667 12.6668C10.6667 15.6123 13.0546 18.0002 16.0001 18.0002Z"
          fill="currentColor"
        />
      </g>
      <path
        d="M7.08848 25.9177C7.89958 24.0068 9.79331 22.6665 12.0001 22.6665H20.0001C22.2069 22.6665 24.1006 24.0068 24.9117 25.9177M21.3334 12.6665C21.3334 15.612 18.9456 17.9998 16.0001 17.9998C13.0546 17.9998 10.6667 15.612 10.6667 12.6665C10.6667 9.72098 13.0546 7.33317 16.0001 7.33317C18.9456 7.33317 21.3334 9.72098 21.3334 12.6665ZM29.3334 15.9998C29.3334 23.3636 23.3639 29.3332 16.0001 29.3332C8.63628 29.3332 2.66675 23.3636 2.66675 15.9998C2.66675 8.63604 8.63628 2.6665 16.0001 2.6665C23.3639 2.6665 29.3334 8.63604 29.3334 15.9998Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default UserCircleIcon;
